import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Title from '../../components/Title/Title';
import {
  CardDescription,
  CardHeader,
  CardTitle,
  CardV2,
} from '../../components/CardV2/CardV2';
import {
  HELP_CENTER_CATEGORIES,
  HELP_CENTER_CATEGORY_ICONS,
} from '../../utils/helpCenterCategories';
import HelpCenterLayout from './HelpCenterLayout';

const HelpCenterPage = () => {
  const { t } = useTranslation();

  return (
    <HelpCenterLayout
      header={
        <>
          <Title text={t('helpCenter.title')} />
          <p className="mt-4 text-slate-700">{t('helpCenter.intro')}</p>
        </>
      }
    >
      <div className="grid gap-4 sm:grid-cols-2">
        {HELP_CENTER_CATEGORIES.map((category) => {
          const Icon = HELP_CENTER_CATEGORY_ICONS[category];
          return (
            <Link
              key={category}
              to={`/help-center/category/${category}`}
              className="block h-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
            >
              <CardV2 className="h-full border-slate-200 bg-white shadow-sm transition hover:border-slate-300 hover:shadow">
                <CardHeader className="space-y-3 p-6">
                  <Icon className="h-6 w-6 text-slate-800" strokeWidth={1.5} />
                  <CardTitle className="text-lg font-bold text-slate-900">
                    {t(`helpCenter.category.${category}`)}
                  </CardTitle>
                  <CardDescription className="text-sm text-slate-500">
                    {t(`helpCenter.category.${category}.description`)}
                  </CardDescription>
                </CardHeader>
              </CardV2>
            </Link>
          );
        })}
      </div>
    </HelpCenterLayout>
  );
};

export default HelpCenterPage;
